import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, message, Spin } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import nodeAPI from "../../../../service/ApiServiceNode";
import EmployeeDetailCard from "./EmployeeDetailCard";
import Projects from "../../Projects";
import "../../project-management.scss";
import "./employee-project-view.scss";
import logger from "../../../../utils/logger";



const EmployeeProjectView = () => {
    const { email } = useParams();
    const navigate = useNavigate();
    const [employeeData, setEmployeeData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Fetch employee details
    const fetchEmployeeDetails = async () => {
        setLoading(true);
        try {
            const response = await nodeAPI.get(`/project/employees/${encodeURIComponent(email)}/details`);
            
            if (response.data && response.data.statusCode) {
                if (response.data.statusCode === 1 || response.data.statusCode.code === 1) {
                    setEmployeeData(response.data.data?.employee || response.data.employee);
                } else {
                    message.error(response.data.statusCode?.msg || "Failed to fetch employee details");
                }
            } else if (response.data) {
                setEmployeeData(response.data.data?.employee || response.data.employee || response.data);
            }
        } catch (error) {
            logger.error("Error fetching employee details:", error);
            message.error("Failed to fetch employee details");
        } finally {
            setLoading(false);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (email) {
            fetchEmployeeDetails();
        }
    }, [email]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleBackToEmployees = () => {
        navigate("/project-management?tab=employees");
    };

    if (loading) {
        return (
            <div className="wrapper-grey" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!employeeData) {
        return (
            <div className="wrapper-grey">
                <div className="employee-project-header">
                    <Button 
                        className="back-button"
                        onClick={handleBackToEmployees}
                        icon={<ArrowLeftOutlined />}
                    >
                        Back to Employees
                    </Button>
                    <h4 className="page-title">Employee Not Found</h4>
                </div>
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    <p>Employee not found</p>
                </div>
            </div>
        );
    }

    return (
        <div className="wrapper-grey employee-project-view">
            <div className="employee-project-header">
                <Button 
                    className="back-button"
                    onClick={handleBackToEmployees}
                    icon={<ArrowLeftOutlined />}
                >
                    Back to Employees
                </Button>
                <h4 className="page-title">List Project By {employeeData.fullName || employeeData.firstName}</h4>
            </div>

            {/* Employee Detail Card */}
            <EmployeeDetailCard employee={employeeData} />

            {/* Projects Component - reuse existing Projects component with employee filter */}
            <Projects 
                assignedUserEmail={email}
                showHeader={false}
                hideAddButton={true}
                pageTitle={`Projects assigned to ${employeeData.fullName || employeeData.firstName}`}
            />
        </div>
    );
};

export default EmployeeProjectView;
